import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService, User } from '@auth0/auth0-angular';
import { map } from 'rxjs/operators';
import { CodeSnippetComponent } from './code-snippet.component';
import { Observable } from 'rxjs';

@Component({
    standalone: true,
    selector: 'webrendel-profile',
    templateUrl: './profile.component.html',
    imports: [CommonModule, CodeSnippetComponent],
})
export class ProfileComponent {
    user$: Observable<User | null | undefined>;
    code$: Observable<string>;
    title = 'Decoded ID Token';

    constructor(private authService: AuthService) {
        this.user$ = this.authService.user$;
        this.code$ = this.user$.pipe(
            map((user: User | null | undefined) => JSON.stringify(user, null, 2))
        );
    }
}
